import React from "react";
import MainContent from "../../components/mainContent/MainContent";
import GestionEnviosContent from "./components/GestionEnviosContent";

export default function GestionEnvios() {
  return (
    <>
      <MainContent
        component={<GestionEnviosContent />}
        titulo={"Gestión envíos"}
        noBackground
        tableMaxWidth
      />
    </>
  );
}
